import { useEffect, useRef } from 'react';
import {
  addConsentListener,
  removeConsentListenerById,
  getConsentState,
} from '@tcc/analytics';
import * as braze from '@braze/web-sdk';
import { useLoggedInUser } from '@tcc/shared-data-lib';
import { useUserLoggedInConfigs } from '../utils/sharedData';

export const APP_KEY = '28ca822b-4d7f-4cc8-bfd3-21a1f6f227f3';

const initialize = (uuid) => {
  if (braze.isInitialized()) return;

  braze.initialize(APP_KEY, {
    baseUrl: 'sdk.iad-01.braze.com',
    enableLogging: true,
    allowUserSuppliedJavascript: true,
  });

  braze.automaticallyShowInAppMessages();
  braze.changeUser(uuid);
  braze.openSession();
};

const stop = () => {
  braze.changeUser(null as unknown as string);
  braze.disableSDK();
  braze.destroy();
};

export const useMarketingNotifications = () => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const consentListenerId = useRef<symbol | undefined>();

  useEffect(() => {
    if (user?.uuid) {
      const { hasAnalyticsConsent } = getConsentState();
      if (hasAnalyticsConsent) initialize(user.uuid);

      // @ts-expect-error this is fine
      consentListenerId.current = addConsentListener(
        ({ hasAnalyticsConsent }) => {
          if (hasAnalyticsConsent) {
            initialize(user.uuid);
          } else {
            stop();
          }
        }
      );
    }

    return () => {
      if (consentListenerId.current)
        removeConsentListenerById(consentListenerId.current);
    };
  }, [user]);
};
